<template>
  <b-container class="container">
    <b-row class="logoutContainer" align-h="center" align-v="center">
      <b-col :lg="6" class="loginWrapper p-4"> See you soon! </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from '@/admin/api.js';
import store from '@/admin/store.js';

export default {
  name: 'LogoutScreen',
  data() {
    return {};
  },
  created() {
    localStorage.removeItem('token_a');
    store.setAuth(false, null, null, null);
    this.$router.replace({ name: 'LoginScreen' });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.logoutContainer {
  height: 100%;
}
.loginWrapper {
  background-color: white;
  border-radius: 0.35rem;
}
</style>
